import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.regexp.constructor.js";
import "core-js/modules/es6.object.define-property.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*jshint esversion: 6 */

/**
 * Helps to renders error message on the screen
 */
export var ErrorBuilder = /*#__PURE__*/function () {
  function ErrorBuilder() {
    _classCallCheck(this, ErrorBuilder);
  }

  _createClass(ErrorBuilder, null, [{
    key: "RenderHandler",
    value:
    /**
     * A wrapper around Render method for catch()
     * Usage: promise.catch(ErrorBuilder.RenderHandler(errorDOMContainer));
     * @param {DOM node} container
     */
    function RenderHandler(container, i18n) {
      var _this = this;

      return function (error) {
        _this.Render(container, error, i18n);
      };
    }
    /**
     * Renders the validation part of an error message if applicable
     * @param {object} error - error object
     */

  }, {
    key: "GetValidationError",
    value: function GetValidationError(error) {
      var errorMessage = "";

      if (error.type && error.type == "https://tools.ietf.org/html/rfc7231#section-6.5.1") {
        //{"type":"https://tools.ietf.org/html/rfc7231#section-6.5.1","title":"One or more validation errors occurred.","status":400,"traceId":"|741ab745-441eae0cac4b73b5.","errors":{"Address.AddressLine1":["potentially unsafe data detected in AddressLine1"]}}
        if (error.title) {
          errorMessage = error.title.replace(/[ \.]+$/, "");
        }
      }

      if (error.errors) {
        if (errorMessage !== "") {
          errorMessage += ": ";
        }

        Object.keys(error.errors).forEach(function (key) {
          errorMessage += "".concat(error.errors[key][0], "; ");
        });
      }

      if (error.status === 422) {
        if (errorMessage !== "") {
          errorMessage += ": ";
        }

        Object.keys(error.message).forEach(function (key) {
          errorMessage += "".concat(error.errors[key][0], "; ");
        });
      }

      return errorMessage;
    }
    /**
     * Renders error message in the provided container
     * Usage: promise.catch((error) => { ErrorBuilder.Render(errorDOMContainer, error); })
     * @param {DOM Node} container - Parent DOM container
     * @param {object} error - error object
     * @param {object} i18n - localized labels
     */

  }, {
    key: "Render",
    value: function Render(container, error, i18n) {
      if (!!container) {
        if (!error) {
          error = "Unidentified error occurred";
        } else if (error.status == 404) {
          error = "Not found";
        }

        if (!!error.IsLocalizable && !!i18n && !!error.Values) {
          var errorMessage = i18n[error.Details] || error.Details;

          if (!!error.Values) {
            for (var key in error.Values) {
              if (error.Values.hasOwnProperty(key)) {
                errorMessage = errorMessage.replace(new RegExp("\\[".concat(key, "\\]"), "ig"), error.Values[key]);
              }
            }
          }

          error = errorMessage;
        } else if (error.status == 422 || error.type && error.type == "https://tools.ietf.org/html/rfc7231#section-6.5.1") {
          error = GetValidationError(error);
        } else {
          error = error.message || error.Message || error.details || error.Details || error;
        }

        console.error(error);
        container.innerHTML =  `<div class="mppw-alert mppw-alert__danger"><div class="mppw-alert__icon"></div><span class="mppw-alert__text">${error}</span></div>` ;
      }
    }
    /**
     * Renders alert message in the provided container
     * Usage: promise.catch(ErrorBuilder.RenderAlert(errorDOMContainer, type, message))
     * @param {DOM Node} container
     * @param {string} type
     * @param {string} message
     */

  }, {
    key: "RenderAlert",
    value: function RenderAlert(container, type, message) {
      if (!!container) {
        type = type || 'danger';
        message = message || 'Default alert message';
        container.innerHTML +=  `<div class="mppw-alert mppw-alert__${type}"><div class="mppw-alert__icon"></div><span class="mppw-alert__text">${message}</span></div>` ;
      }
    }
  }, {
    key: "ClearAllAlerts",
    value:
    /**
     * Clears any alerts that are displayed
     * @param {DOM Node} container
     */
    function ClearAllAlerts(container) {
      if (!!container) {
        container.innerHTML = '';
      }
    }
  }]);

  return ErrorBuilder;
}();